import React from 'react';
import {
  DataTableExpandableRows,
  DataTableExpandableRowsProps,
  ExpandableDataTableRow,
} from './DataTableExpandableRows';
import { useVerticalResize } from './hooks/useVerticalResize';

export interface ResizableDataTableExpandableRowsProps<TRow extends ExpandableDataTableRow>
  extends Omit<DataTableExpandableRowsProps<TRow>, 'enableVerticalResize'> {
  initialHeight?: number;
  minHeight?: number;
}

/**
 * ResizableDataTableExpandableRows
 *
 * A wrapper component that adds vertical resize functionality to DataTableExpandableRows.
 * Users can drag the bottom border to resize the table height.
 */

export function ResizableDataTableExpandableRows<TRow extends ExpandableDataTableRow>({
  initialHeight = 400,
  minHeight = 200,
  ...tableProps
}: ResizableDataTableExpandableRowsProps<TRow>) {
  const { height, containerRef, ResizeHandle } = useVerticalResize({
    initialHeight,
    minHeight,
  });

  const containerStyle: React.CSSProperties = {
    height: `${height}px`,
    position: 'relative',
  };

  return (
    <div ref={containerRef} style={containerStyle}>
      <DataTableExpandableRows
        {...tableProps}
        // Make the table fill the container height
        tableMaxHeight="100%"
      />
      {ResizeHandle}
    </div>
  );
}
